module.exports = __webpack_public_path__ + "static/portfolio-6-459f4d8718ca7d85fc336d746ed112f7.jpg";